import React from 'react';
import { Platform } from 'react-native';

interface WebFormProps {
  children: React.ReactNode;
  /** Called on native form submit (Enter key in any field) AND when our
   *  own submit button is pressed (the caller wires both — this is only
   *  the native HTML-form path). Must `preventDefault` itself; we do
   *  that for you, just pass the user-level handler. */
  onSubmit: () => void;
}

/**
 * Wraps `children` in a real HTML `<form>` on web and is a transparent
 * pass-through on native (RN iOS / Android).
 *
 * Why this exists: Safari's iCloud Keychain interception of password
 * fields behaves differently depending on whether the inputs live
 * inside a proper `<form>` tag. By default RN-Web renders everything as
 * `<div>`s, so Safari sees a collection of loose inputs and falls back
 * to its most aggressive Keychain heuristics on each one individually.
 * Wrapping in `<form>` gives Safari the credential-form context it
 * expects and tends to relax its in-field UI injection (the
 * `-webkit-credentials-auto-fill-button`). Plus pressing Enter in any
 * field now correctly triggers submit, which matches the browser
 * convention everywhere else on the web.
 *
 * Used by the three auth screens (Login / Register / ResetPassword).
 */
export const WebForm: React.FC<WebFormProps> = ({ children, onSubmit }) => {
  if (Platform.OS === 'web') {
    return (
      <form
        onSubmit={(e: any) => {
          e.preventDefault();
          onSubmit();
        }}
        style={{ width: '100%' }}
      >
        {children}
      </form>
    );
  }
  return <>{children}</>;
};
